"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const straighthair = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-straighthair` : '') + (description ? ` desc-straighthair` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-straighthair"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-straighthair"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 22.08V1.81A.98.98 0 0 0 7 1c-.55 0-1 .4-1 .92v20.27A1 1 0 0 0 7 23c.55 0 1-.4 1-.92Zm5 0V1.81A.98.98 0 0 0 12 1c-.55 0-1 .4-1 .92v20.27a1 1 0 0 0 1 .81c.55 0 1-.4 1-.92Zm5-20.16v20.16c0 .51-.45.92-1 .92a.98.98 0 0 1-1-.8V1.91c0-.51.45-.92 1-.92a1 1 0 0 1 1 .8v.12Z",
    fill: "#232323"
  }));
};
var _default = exports.default = straighthair;